import React, { Component } from 'react';

import { Redirect } from 'react-router-dom';
import { request, handleRequestErrors } from '../../helpers/Requests'

import PersonHeader from '../components/PersonHeader';
import Page from '../../components/shared/Page';
import { renderErrors } from '../../utilities/Forms.js'

class PersonPreferencesLogin extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleDetailsSubmit = this.handleDetailsSubmit.bind(this);
    this.handleOTPSubmit = this.handleOTPSubmit.bind(this);
  }

  state = {
    details: "",
    one_time_passcode: "",

    oneTimePasscodePage: false,
    loggedIn: false,
    errors: ""
  }

  handleChange(event) {
    let name = event.target.name;
    let value = event.target.value;

    this.setState({[name]: value});
  }

  handleDetailsSubmit(event) {
    this.setState({ submitting: true })

    var json = {
      "person_sessions": {
        "details": this.state.details
      }
    }

    request("POST", `/v1/p/person_sessions/start`, JSON.stringify(json), () => {this.setState({ unauthorized: true })})
      .then(data => { this.setState({ oneTimePasscodePage: true, submitting: false, errors: "" }) })
      .catch(error => handleRequestErrors(this, error, { submitting: false }))

    event.preventDefault();
  }

  handleOTPSubmit(event) {
    this.setState({ submitting: true })

    var json = {
      "person_sessions": {
        "details": this.state.details,
        "one_time_passcode": this.state.one_time_passcode
      }
    }

    request("POST", `/v1/p/person_sessions`, JSON.stringify(json), () => {this.setState({ unauthorized: true })})
      .then(data => { this.setState({ loggedIn: true, submitting: false, errors: "" }) })
      .catch(error => handleRequestErrors(this, error, { submitting: false }))

    event.preventDefault();
  }

  loading() {
    if (this.state.submitting) {
      return (
        <div>
          Logging in
          <span className="blink1">.</span>
          <span className="blink2">.</span>
          <span className="blink3">.</span>
        </div>
      )
    }
  }

  render() {
    const { details, one_time_passcode, oneTimePasscodePage, error } = this.state;

    if (error) {
      return <div>{error.message}</div>
    }

    if (this.state.loggedIn) {
      return <Redirect to={{ pathname: "/person-preferences" }} />
    }

    if (oneTimePasscodePage === false) {
      return (
        <Page header={PersonHeader} title={`Person Preferences`}>

          <div className="login-form">
            <p>Please enter a phone or email to continue</p>
            <form onSubmit={this.handleDetailsSubmit}>
              {renderErrors(this.state.errors, "error", "")}

              <label>
                <input placeholder=" phone or email" aria-required="true" type="text" key="details" name="details" value={details} autoComplete="email" onChange={this.handleChange} />
              </label>
              <br />
              <input type="submit" value="Submit" />

              {this.loading()}
            </form>


            <a className="block center small" target="_blank" rel="noopener noreferrer" href='https://www.dreception.com/docs/privacy-policy'>Privacy Policy</a>
          </div>
        </Page>
      )
    }

    return (
        <Page header={PersonHeader} title={`Person Preferences`}>

          <div className="login-form">
            <p>Please enter the One Time Passcode</p>
            <form onSubmit={this.handleOTPSubmit}>
              {renderErrors(this.state.errors, "error", "")}

              <label>
                <input placeholder="one time passcode" aria-required="true" type="text" key="one_time_passcode" name="one_time_passcode" value={one_time_passcode} autoComplete="off" onChange={this.handleChange} />
              </label>
              <br />
              <input type="submit" value="Submit" />

              {this.loading()}
            </form>


            <a className="block center small" target="_blank" rel="noopener noreferrer" href='https://www.dreception.com/docs/privacy-policy'>Privacy Policy</a>
          </div>
        </Page>
      )
  }
}

export default PersonPreferencesLogin;
